import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15fd8549"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "campus-collect-page font-Pretendar"
}
const _hoisted_2 = { class: "step-container" }
const _hoisted_3 = { class: "step-progress" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-circle" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "step-text" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, " 보낼 물건 "),
    /*#__PURE__*/_createElementVNode("div", { class: "step-subtitle" }, " 선택하기 ")
  ])
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-circle" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "step-text" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, " 주의사항 "),
    /*#__PURE__*/_createElementVNode("div", { class: "step-subtitle" }, " 확인하기 ")
  ])
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-line" }, null, -1))
const _hoisted_9 = { class: "content-section" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-sm-5 pt-sm-5" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "cola-color"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "fw-bold text-20 text-80" }, " 어떤 물건을 보낼까요? ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-14 text-52" }, [
    /*#__PURE__*/_createTextVNode(" 꼭 확인해주세요 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 투명 음료 페트병이 아닌 다른 물건을 보내시는 경우,"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 리워드 혜택을 받을 수 없어요! ")
  ])
], -1))
const _hoisted_14 = { class: "option-container" }
const _hoisted_15 = {
  key: 0,
  class: "checkmark",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "3",
  d: "M5 13l4 4L19 7"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "option-text text-60" }, "투명 음료 페트병", -1))
const _hoisted_19 = { class: "action-container" }
const _hoisted_20 = {
  key: 1,
  class: "content-section cola-color"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "fw-bold text-20 text-80" }, [
  /*#__PURE__*/_createTextVNode(" 캠퍼스 챌린지 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" GS25 반값택배 예약하기 ")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mt-5 text-16 text-60" }, [
  /*#__PURE__*/_createTextVNode(" 원더플 캠페인 제로 웨이스트 박스만 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 이용할 수 있어요 ")
], -1))
const _hoisted_23 = { class: "action-container" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "display-4 mt-5 fw-bold pt-5 text-20 text-80" }, " 예약을 끝냈어요! ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-3 mt-sm-5 lh-sm d-none d-sm-block text-60" }, [
  /*#__PURE__*/_createTextVNode(" 선택하신 GS25 편의점에 방문해 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 택배를 보내주세요. ")
], -1))
const _hoisted_26 = { class: "reservation-card" }
const _hoisted_27 = { class: "reservation-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reservation-label" }, " 예약번호 ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reservation-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "reservation-label" }, " 보내는 물건 "),
  /*#__PURE__*/_createElementVNode("div", { class: "reservation-value" }, " 투명 음료 페트병 ")
], -1))
const _hoisted_30 = { class: "reservation-item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reservation-label" }, " 접수 기간 ", -1))
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"usage-container font-Pretendar\" data-v-15fd8549><div class=\"usage-guide\" data-v-15fd8549><h2 class=\"guide-title text-20\" data-v-15fd8549> GS25 편의점 반값택배 이용방법 </h2><div class=\"guide-steps\" data-v-15fd8549><div class=\"guide-step\" data-v-15fd8549><div class=\"step-number\" data-v-15fd8549> 1 </div><div class=\"step-content\" data-v-15fd8549> 미리 포장한 제로 웨이스트 박스를 가지고 선택하신<br data-v-15fd8549> GS25 편의점으로 방문해 주세요. </div></div><div class=\"guide-step\" data-v-15fd8549><div class=\"step-number\" data-v-15fd8549> 2 </div><div class=\"step-content\" data-v-15fd8549> 포스트박스 기계 화면에서 예약 접수 버튼을 눌러주세요. </div></div><div class=\"guide-step\" data-v-15fd8549><div class=\"step-number\" data-v-15fd8549> 3 </div><div class=\"step-content\" data-v-15fd8549> 운송장 출력 후 박스 상단에 붙여주세요. </div></div><div class=\"guide-step\" data-v-15fd8549><div class=\"step-number\" data-v-15fd8549> 4 </div><div class=\"step-content\" data-v-15fd8549> 접수 고객 보관용/포스 스캐용 QR코드를 계산대 점원에게<br data-v-15fd8549> 반드시 보여주세요! </div></div></div></div></div>", 1)
const _hoisted_33 = { class: "footer-btn-group" }

import { inject, nextTick, reactive, ref } from 'vue';
import ColaButton from '@/templates/campaign-cocacola-season-6/components/cola-button.vue';
import ParticipateSuccess from '@/templates/campaign-cocacola-season-6/components/participate-success.vue';
import CampusCollectRound2 from '@/templates/campaign-cocacola-season-6/components/campus-collect-round2.vue';
import { request } from '@/utils';
import _ from 'lodash';
import PopupError from '@/templates/campaign-cocacola-season-6/components/popups/popup-error.vue';
import dayjs from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const programStepData: any = inject('programStepData');
const isSelected = ref(false);

const gs_order_no = ref('');
const due_date = ref('');

const errMsg = ref('');
const popupVisible = reactive({
  error: false,
});

const toggleSelection = () => {
  isSelected.value = !isSelected.value;
};

const activeSteps = ref({
  step1: true,
  step2: false,
  finished: false
});

const nextStep = async (stepName: string) => {
  if (stepName === 'step1') {
    activeSteps.value.step1 = false;
    activeSteps.value.step2 = true;
  } else if (stepName === 'step2') {
    await onStep2Submit();
    await loadReservationDetails();
  }
};

const loadReservationDetails = async (retryCount = 0) => {
  const maxRetries = 5;

  try {
    const response = await request.get('user_requests', {
      params: {
        target_id_eq: programStepData.value.programId,
        target_type_eq: 'Program',
        type_eq: 'CollectionRequest',
      }
    });

    const data = response.data;
    if (data.length > 0) {
      const gs25Requested = data.find((item: any) => item.user_request_program_shipment !== null && item.user_request_program_shipment.delivery_method === 'gs25' && item.user_request_program_shipment.gs_order_no);
      if (gs25Requested) {
        gs_order_no.value = gs25Requested.user_request_program_shipment.gs_order_no || '';
        const date = new Date(gs25Requested.user_request_program_shipment.created_at);
        due_date.value = dayjs(date).add(3, 'day').format('YYYY.MM.DD');
      }
    }

    if (!gs_order_no.value && retryCount < maxRetries) {
      setTimeout(() => {
        loadReservationDetails(retryCount + 1);
      }, 2000); // Wait 2 seconds before retrying
    }
  } catch (error) {
    if (retryCount < maxRetries) {
      setTimeout(() => {
        loadReservationDetails(retryCount + 1);
      }, 2000); // Wait 2 seconds before retrying
    }
  }
};

async function onStep2Submit() {
  try {
    await request.post('user_requests', {
      target_id: programStepData.value.programId,
      target_type: 'Program',
      type: 'CollectionRequest'
    }, {
      loading: { silent: true }
    });

    activeSteps.value.step2 = false;
    activeSteps.value.finished = true;
  } catch (e) {
    const errorMsg = _.get(e, 'message');
    // const code = _.get(e, 'code');
    // const status = _.get(e, 'status');
    // // 项目人次达到上限，需要显示错误信息并提示是否订阅 waiting list
    // if (status !== 401 && String(code) === '40008') {
    //   requestWaitingListsMessage.value = errorMsg;
    //   await showPopup('requestWaitingLists');
    //   return;
    // }

    errMsg.value = errorMsg;

    await showPopup('error');
    throw e;
  }
}



async function showPopup(key: keyof typeof popupVisible) {
  // hidePopup();
  await nextTick();
  popupVisible[key] = true;
}

function hidePopup(key?: keyof typeof popupVisible) {
  if (key) {
    popupVisible[key] = false;
  } else {
    _.forEach(popupVisible, (val, key) => {
      if (val) {
        popupVisible[key] = false;
      }
    });
  }
}

// Functions removed as they were not being used in the template

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!activeSteps.value.finished)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_unref(programStepData).isCampusCollectSuccess == false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["step-line", {'active': activeSteps.value.step1 || activeSteps.value.step2}])
                    }, null, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["step-item", {'active': activeSteps.value.step1}])
                    }, _hoisted_5, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["step-line", {'active': activeSteps.value.step2}])
                    }, null, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["step-item", {'active': activeSteps.value.step2}])
                    }, _hoisted_7, 2),
                    _hoisted_8
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  (activeSteps.value.step1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _hoisted_12,
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", {
                            class: "option-item",
                            onClick: toggleSelection
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["option-circle", { active: isSelected.value }])
                            }, [
                              (isSelected.value)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_17))
                                : _createCommentVNode("", true)
                            ], 2),
                            _hoisted_18
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(ColaButton, {
                            title: "다음단계로",
                            border: true,
                            class: "mx-auto",
                            disabled: !isSelected.value,
                            responsive: "",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (nextStep('step1')))
                          }, null, 8, ["disabled"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (activeSteps.value.step2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _hoisted_21,
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(ColaButton, {
                            title: "다음단계로",
                            border: true,
                            class: "mx-auto",
                            disabled: !isSelected.value,
                            responsive: "",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (nextStep('step2')))
                          }, null, 8, ["disabled"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createBlock(CampusCollectRound2, { key: 1 }))
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(ParticipateSuccess, null, {
            default: _withCtx(() => [
              _hoisted_24,
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", {
                    class: _normalizeClass(["reservation-value", { 'skeleton': !gs_order_no.value }])
                  }, _toDisplayString(gs_order_no.value || ' '), 3)
                ]),
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", {
                    class: _normalizeClass(["reservation-value", { 'skeleton': !due_date.value }])
                  }, _toDisplayString(due_date.value) + " 수요일 ", 3)
                ])
              ])
            ]),
            _: 1
          }),
          _hoisted_32
        ], 64)),
    _createVNode(PopupError, {
      modelValue: _unref(popupVisible).error,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(popupVisible).error) = $event)),
      title: errMsg.value
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (hidePopup()))
          }, " 확인했어요 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})